import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

class ConfirmationButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleConfirm() {
    this.setState({ show: false }, () => this.props.onConfirm());
  }

  render() {
  return (
      <>
        <Button className={this.props.className} variant={this.props.variant} type={this.props.type} disabled={this.props.disabled} onClick={this.handleShow.bind(this)}>
          {this.props.buttonText}
        </Button>

        <Modal size="lg" show={this.state.show} onHide={this.handleClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body><p>{this.props.modalBody}</p></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose.bind(this)}>
              Cancel
            </Button>
            <Button variant={this.props.confirmVariant} onClick={this.handleConfirm.bind(this)}>
              {this.props.buttonConfirmText}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default ConfirmationButton;